export const LABEL_OPTIONS = [
  {
    value: 'NILM',
    label: 'NILM',
    color: '#00FF00', // Green
    sublabels: [
      // New clinical subclasses first (requested order)
      'None',
      'Bacterial vaginosis / Shift in Flora',
      'Trichomonas vaginalis',
      'Candida spp.',
      'Actinomyces',
      'Cytomegalo Virus',
      'HPV',
      'RCC',
      'Atrophy', 
      // Existing subclasses pushed below
      'Normal',
      'Inflammatory',
      'Reactive',
    ],
  },
  {
    value: 'ASC-US',
    label: 'ASCUS',
    color: '#FFFF00', // Light yellow
    sublabels: ['None','Atypical', 'Cannot Exclude HSIL'],
  },
  {
    value: 'LSIL',
    label: 'LSIL',
    color: '#FF8C00', // Dark yellow
    sublabels: ['None','HPV Effect', 'Koilocytic'],
  },
  {
    value: 'ASC-H',
    label: 'ASC-H',
    color: '#F3C058', // Orange
    sublabels: ['None','Atypical – Favor HSIL'],
  },
  {
    value: 'HSIL',
    label: 'HSIL',
    color: '#FF0000', // Light red
    sublabels: ['None','Carcinoma In Situ'],
  },
  {
    value: 'SCC',
    label: 'SCC',
    color: '#800000', // Dark red / maroon
    sublabels: ['None','Squamous Cell Carcinoma', 'Keratinizing', 'Non-keratinizing'],
  },
  {
    value: 'AGC',
    label: 'AGC',
    color: '#FF44FF',
    sublabels: ['Endocervical', 'Endometrial', 'NOS'],
  },
  {
    value: 'AIS',
    label: 'AIS',
    color: '#9D00FF',
    sublabels: ['Adenocarcinoma In Situ'],
  },
] as const;

/** Doctor annotation UI: only these 6 classes, in this order. */
export const DOCTOR_LABEL_ORDER = [
  'NILM',
  'ASC-US',
  'LSIL',
  'ASC-H',
  'HSIL',
  'SCC',
] as const;

export const COLORS = DOCTOR_LABEL_ORDER.map(
  (value) => LABEL_OPTIONS.find((o) => o.value === value)!.color,
);

export function findLabelOption(raw: string) {
  const v = raw.trim();
  if (!v) return undefined;
  const lower = v.toLowerCase();
  return (
    LABEL_OPTIONS.find((o) => o.value === v) ||
    LABEL_OPTIONS.find((o) => o.value.toLowerCase() === lower) ||
    LABEL_OPTIONS.find((o) => o.label.toLowerCase() === lower) ||
    (lower === 'normal' ? LABEL_OPTIONS.find((o) => o.value === 'NILM') : undefined) ||
    (lower === 'ascus' ? LABEL_OPTIONS.find((o) => o.value === 'ASC-US') : undefined) ||
    (lower === 'asch' || lower === 'asc-h' ? LABEL_OPTIONS.find((o) => o.value === 'ASC-H') : undefined)
  );
}

/** Doctor dropdown / counts: the 6 primary classes only. */
export function doctorLabelOptions() {
  return DOCTOR_LABEL_ORDER.map(
    (value) => LABEL_OPTIONS.find((o) => o.value === value)!,
  );
}
